import { h, render, Component } from 'preact';

export default class Paginator extends Component {

    state = {
        selectedFilters: {},
        products: window.products,
        filters: window.filters
    }

    onClick = (e) => {
        e.preventDefault();

        if(typeof(this.props.onPage) === 'function') {
            const page = parseInt(e.target.innerText);
            if(this.props.currentPage !== page) {
                this.props.onPage(parseInt(e.target.innerText));
            }
        }
    }

    renderPageItems() {
        let pages = parseInt(this.props.pages);
        const items = [];

        for(let i = 1; i <= pages; i++) {
            items.push(
                <a
                    href="#"
                    onClick={this.onClick}
                    className={`paginator__item ${this.props.currentPage === i ? '_active' : ''}`}>{i}
                </a>
            )
        }

        return items;
    }

    render(props) {
        let pages = parseInt(props.pages) || 0;

        if(pages > 1) {
            return (
                <nav className={`paginator ${props.className}`}>
                    { this.renderPageItems() }
                </nav>
            )
        }
    }
}